<template>
  <div>
    <TitlePage :title="$t('edit')+' '+$t('booking')"></TitlePage>

    <v-layout wrap>

      <v-container>
        <v-row v-if="Object.keys(item).length > 0">
          <v-col cols="12" md="8" class="br-gray">
            <v-list dense>
              <v-list-item dense class="pa-0">
                <v-list-item-icon>
                  <v-icon color="indigo">
                    mdi-account
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content v-if="item.customer[0]">
                  <v-list-item-title style="white-space: break-spaces;">{{item.customer[0].name + ' ' + item.customer[0].surname }} - {{ item.customer[0].email }} <template v-if="item.customer[0].phone"> - <a :href="'tel:+39'+item.customer[0].phone">{{item.customer[0].phone}}</a></template>
                  </v-list-item-title>
                  <v-list-item-subtitle>Utente</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-content v-else-if="item.note">
                  <v-list-item-title>{{item.note}}
                  </v-list-item-title>
                  <v-list-item-subtitle></v-list-item-subtitle>
                </v-list-item-content>

              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item dense class="pa-0">
                <v-list-item-icon>
                  <v-icon color="primary">
                    mdi-clock
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title class="evidence-booking">{{formatDate(item.slot_id) }}
                  </v-list-item-title>
                  <v-list-item-subtitle>Data e Orario
                  </v-list-item-subtitle>
                </v-list-item-content>

              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item class="pa-0">
                <v-list-item-icon>
                  <v-icon color="secondary">
                    mdi-stadium-variant
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.sport[0].name }} - {{ (item.field[0]) ? item.field[0].name : 'N.d.' }}
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="item.center[0]">{{ item.center[0].name }}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-icon v-if="item.center[0] && item.center[0].company_info.phone">
                  <a class="text-decoration-none" :href="'tel:'+item.center[0].company_info.phone"
                     title="Chiama il centro sportivo">
                    <v-icon color="primary">
                      mdi-phone
                    </v-icon>
                  </a>
                </v-list-item-icon>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item class="pa-0">
                <v-list-item-icon>
                  <v-icon color="indigo">
                    mdi-map-marker
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content v-if="item.center[0]">
                  <v-list-item-title>{{ item.center[0].address_complete }}</v-list-item-title>
                  <v-list-item-subtitle>Indirizzo campo</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-icon v-if="item.center[0]">
                  <a class="link-action-center text-decoration-none" target="_blank"
                     :href="'https://maps.google.com/?q='+item.center[0].position.coordinates[1]+','+item.center[0].position.coordinates[0]"
                     title="Indicazioni per raggiungere il centro sportivo">
                    <v-icon color="primary">
                      mdi-map
                    </v-icon>
                  </a>
                </v-list-item-icon>
              </v-list-item>

              <template v-if="item.promo_code">
                <v-divider inset></v-divider>

                <!--
                <v-list-item v-if="item.promo && item.promo.value > 0" class="pa-0">
                  <v-list-item-icon>
                    <v-icon color="primary">
                      mdi-label-percent
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Promozione: -{{item.promo.value}} {{item.promo.type == 'fixed'? '€':'%'}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                -->

                <v-list-item v-if="item.promo_code" class="pa-0">
                  <v-list-item-icon>
                    <v-icon color="primary">
                      mdi-label-percent
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Promo Code: {{item.promo_code}} -{{item.promo_code_detail.value}} {{item.promo_code_detail.type == 'fixed'? '€':'%'}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

              </template>

              <template v-if="item.customer[0]">
                <v-divider inset></v-divider>
                <v-list-item class="pa-0">
                  <v-list-item-icon>
                    <v-icon color="primary">
                      mdi-android-messages
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Note: {{(item.note) ? item.note : 'nessuna'}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>


              <v-divider inset></v-divider>

              <v-list-item class="pa-0">
                <v-list-item-icon>
                  <v-icon color="primary">
                    mdi-database-clock
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>Ultimo Aggiornamento {{new Date(item.updated_at).toLocaleString()}}</v-list-item-title>
                  <v-list-item-subtitle>Prenotazione Creata {{new Date(item.created_at).toLocaleString()}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

            </v-list>
          </v-col>
          <v-col cols="12" md="4">
            <template v-if="getPrice(item, 'online') == 0">
              <v-btn class="mt-2" outlined color="indigo" small block>
                DA PAGARE AL CAMPO
              </v-btn>
            </template>
            <template v-else-if="getPrice(item, 'center') == 0 && item.promo_sa_global">
              <v-btn class="mt-2" outlined color="indigo" small block>
                PAGATO ONLINE A UCAMP
              </v-btn>
            </template>
            <template v-else-if="getPrice(item, 'center') == 0 && !item.promo_sa_global">
              <v-btn class="mt-2" outlined color="indigo" small block>
                PAGATO ONLINE AL CENTRO SPORTIVO
              </v-btn>
            </template>
            <QrcodeVue :value="qr_url_prefix+item.code" size="150" level="H" class="mt-2 text-center" v-if="item.status == 'booked'"/>
            <v-btn block :color="getStatus(item.status, 'color')">{{ getStatus(item.status, 'name') }}</v-btn>
            <v-btn block color="primary" class="mt-3">
              {{ this.item.code }}
            </v-btn>
            <template v-if="item.status == 'booked' || item.status == 'to_be_confirmed'">
              <div class="text-center">
                <v-btn class="mt-2" color="error" small @click="cancel" v-if="hours_difference >= -168 && (!item.promo_sa_global || (item.promo_sa_global && getUser.super_admin))">
                  ANNULLA PRENOTAZIONE
                </v-btn>
                <v-btn class="ml-2 mt-2" color="success" small @click="confirm" v-if="hours_difference <=1">
                  CONFERMA PAGAMENTO
                </v-btn>
              </div>

            </template>
          </v-col>

          <v-col cols="12" v-if="(item.promo_sa_global && getUser.super_admin) || !item.promo_sa_global">
            <v-divider></v-divider>
            <div class="pt-5">
              <h5>Riepilogo Costi</h5>
              <v-simple-table dense class="pt-5">
                <template v-slot:default>
                  <tbody>
                  <tr>
                    <td>Importo Totale</td>
                    <td><span :class="(item.promo || item.promo_sa_global) ? 'price-promo':'price'">{{getPrice(item, 'total').toFixed(2)}} €</span></td>
                  </tr>
                  <tr>
                    <td>Importo Pagamento Centro Sportivo</td>
                    <td>{{getPrice(item, 'center').toFixed(2)}} €</td>
                  </tr>
                  <tr>
                    <td>Importo Pagamento Online</td>
                    <td>{{getPrice(item, 'online').toFixed(2)}} €</td>
                  </tr>
                  <tr>
                    <td>% Percentuale Pagamento Centro Sportivo </td>
                    <td>{{ item.split_payment.center_percentage }} %</td>
                  </tr>
                  <tr>
                    <td>% Percentuale Pagamento Online </td>
                    <td>{{ item.split_payment.online_percentage }} %</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-col>

          <v-col cols="12" v-if="(item.promo_sa_global && getUser.super_admin) || !item.promo_sa_global">
            <v-divider></v-divider>
            <div class="pt-5">
              <h5>Riepilogo Transazioni</h5>
              <v-simple-table dense class="pt-5">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-left">
                      Tipo
                    </th>
                    <th class="text-left">
                      Importo
                    </th>
                    <th class="text-left">
                      Mittente
                    </th>
                    <th class="text-left">
                      Destinatario
                    </th>
                    <th class="text-left">
                      Status
                    </th>
                    <th class="text-left">
                      Data
                    </th>
                    <th class="text-left">
                      Note
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="transaction in transactions">
                    <tr>
                      <td>{{ getType(transaction.type) }}</td>
                      <td>{{ transaction.amount.toFixed(2)}} €</td>
                      <td>{{ getActor(transaction.sender_type)}}</td>
                      <td>{{ getActor(transaction.receiver_type)}}</td>
                      <td><v-chip small :color="getStatus(transaction.status, 'color')">{{ getStatus(transaction.status, 'name') }}</v-chip></td>
                      <td>{{ new Date(transaction.created_at).toLocaleString()}}</td>
                      <td>{{ transaction.note}}</td>
                    </tr>
                    <tr v-if="transaction.paypal_data && transaction.paypal_data.id">
                      <td><v-icon small class="mr-2">mdi-information-outline</v-icon>Dati pagamento PayPal</td>
                      <td>Codice Transazione</td>
                      <td>{{transaction.paypal_data.purchase_units[0].payments.captures[0].id}}</td>
                      <td>Email Account Paypal</td>
                      <td>{{(transaction.paypal_data.payer && transaction.paypal_data.payer.email_address) ? transaction.paypal_data.payer.email_address : ''}}</td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr v-if="transaction.stripe_data">
                      <td><v-icon small class="mr-2">mdi-information-outline</v-icon>Dati pagamento Stripe</td>
                      <td>Id Checkout - Payment Id</td>
                      <td>{{transaction.stripe_data.session.id}} - {{transaction.stripe_data.session.payment_intent}}</td>
                      <td>Email Account</td>
                      <td>{{(transaction.stripe_data.session.customer_details && transaction.stripe_data.session.customer_details.email) ? transaction.stripe_data.session.customer_details.email : ''}}</td>
                      <td>{{transaction.stripe_data.session.payment_status}} - {{transaction.stripe_data.session.status}}</td>
                      <td></td>
                    </tr>
                  </template>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-col>

          <v-col cols="12" v-if="cancellation[0]">
            <v-divider></v-divider>
            <div class="pt-5">
              <h5>Riepilogo Cancellazione</h5>
              <v-simple-table dense class="pt-5">
                <template v-slot:default>
                  <tbody>
                  <tr>
                    <td>Tipo Rimborso</td>
                    <td>{{getTypeCancellation(cancellation[0].refund.type)}}</td>
                  </tr>
                  <tr>
                    <td>Importo Rimborso</td>
                    <td>{{cancellation[0].refund.value.toFixed(2)}} €</td>
                  </tr>
                  <tr>
                    <td>Status</td>
                    <td><v-chip small :color="getStatus(cancellation[0].status, 'color')">{{ getStatus(cancellation[0].status, 'name') }}</v-chip></td>
                  </tr>
                  <tr>
                    <td>N° Ore prima </td>
                    <td>{{ cancellation[0].hours_before }} ore</td>
                  </tr>
                  <tr v-if="cancellation[0].promo_code_refund">
                    <td>Promo Code</td>
                    <td>{{ cancellation[0].promo_code_refund }}</td>
                  </tr>
                  <tr>
                    <td>Motivazione </td>
                    <td>{{ cancellation[0].reason }}</td>
                  </tr>
                  <tr>
                    <td>Data</td>
                    <td>{{ new Date(cancellation[0].created_at).toLocaleString()}}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-col>

        </v-row>
      </v-container>


      <v-flex md12 class="pt-10 d-flex">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
        <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
      </v-flex>
    </v-layout>

    <v-dialog v-model="modal_cancel" max-width="800" transition="dialog-bottom-transition" persistent v-if="booking_cancel._id">
      <v-card class="pa-5">
        <v-card-text class="pa-0">
          <div class="close-icon" @click="closeModal('modal_cancel')">
            <v-icon>mdi-close</v-icon>
          </div>
          <v-row>
            <v-col cols="12">
              <div class="text-center">
                <template v-if="this.hours_difference >= 36">
                  <template v-if="booking_cancel.promo_sa_global">
                    <p class="pa-0 ma-0 text-help">
                      Annullando la prenotazione ora,<br/>l'utente riceverà subito un Codice Sconto che gli garantisce uno sconto pari al 20%
                      <br/> dell'importo pagato sulla prossima prenotazione
                    </p>
                  </template>
                  <template v-else-if="+booking_cancel.split_payment.online_percentage == 100">
                    <p class="pa-0 ma-0 text-help">Annullando la prenotazione ora, <br/>l'utente riceverà in circa 3-5 giorni lavorativi il Rimborso completo tramite PayPal
                      <br/>dell'importo pagato online, escludendo le tasse (circa 0,50 €)
                    </p>
                  </template>
                  <template v-else-if="+booking_cancel.split_payment.center_percentage == 100">
                    <p class="pa-0 ma-0 text-help">Annullando la prenotazione ora, <br/>l'utente non incorre in alcuna penale</p>
                  </template>
                  <template v-else-if="+booking_cancel.split_payment.online_percentage > 0">
                    <p class="pa-0 ma-0 text-help">Annullando la prenotazione ora, <br/>l'utente riceverà in circa 3-5 giorni lavorativi il Rimborso completo tramite PayPal <br/>
                      dell'importo pagato online, escludendo le tasse (circa 0,50 €)</p>
                  </template>
                </template>
                <template v-else-if="this.hours_difference >= 12 && this.hours_difference <36">
                  <template v-if="booking_cancel.promo_sa_global">
                    <p class="pa-0 ma-0 text-help">Annullando la prenotazione ora,
                      <br/>l'utente riceverà subito un Codice Sconto che gli garantisce uno sconto pari al 15% <br/>dell'importo pagato, da utilizzare sulla prossima prenotazione
                    </p>
                  </template>
                  <template v-else-if="+booking_cancel.split_payment.online_percentage == 100">
                    <p class="pa-0 ma-0 text-help">Annullando la prenotazione ora,
                      <br/>l'utente riceverà in circa 3-5 giorni lavorativi il Rimborso tramite PayPal del 50% <br/>dell'importo pagato online, escludendo le tasse (circa 0,50 €)
                    </p>
                  </template>
                  <template v-else-if="+booking_cancel.split_payment.center_percentage == 100">
                    <p class="pa-0 ma-0 text-help">Annullando ora la prenotazione online, <br/>
                      l'utente non potrà ricevere ricevere alcun rimborso online, è a discrezione del centro trovare un accordo.
                    </p>
                  </template>
                  <template v-else-if="+booking_cancel.split_payment.online_percentage > 0">
                    <p class="pa-0 ma-0 text-help">Annullando la prenotazione ora,
                      <br/>l'utente riceverà in circa 3-5 giorni lavorativi il Rimborso tramite PayPal del 50% <br/> dell'importo pagato online, escludendo le tasse (circa 0,50 €)
                    </p>
                  </template>
                </template>
                <template v-if="this.hours_difference < 12">
                  <p class="pa-0 ma-0 text-help">Annullando ora la prenotazione online, <br/>
                    l'utente non potrà ricevere ricevere alcun rimborso online, è a discrezione del centro trovare un accordo.
                  </p>
                </template>
                <template>
                  <v-form @submit.prevent="tryCancelBooking()" class="bb-gray pb-5" ref="form_cancel" v-model="valid_form_cancel">
                    <v-radio-group
                        v-model="reason_choice"
                        row
                    >
                      <template v-for="reason in cancellationReason">
                        <v-radio
                            :label="reason.name"
                            :value="reason.name"
                            class="custom-radio"
                        ></v-radio>
                      </template>
                    </v-radio-group>

                    <v-textarea
                        v-if="reason_choice === 'Altro'"
                        outlined
                        name="reason"
                        label="Motivazione"
                        v-model="booking_cancel.reason"
                        :rules="[rules.required, rules.length]"
                    ></v-textarea>

                    <v-btn color="error" class="ma-2 white--text text-center" type="submit">
                      <v-icon left dark>mdi-cash-refund</v-icon>
                      RICHIEDI CANCELLAZIONE
                    </v-btn>
                  </v-form>
                </template>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modal_confirm" max-width="800" transition="dialog-bottom-transition" persistent v-if="booking_confirm._id">
      <v-card class="pa-5">
        <v-card-text class="pa-0">
          <div class="close-icon" @click="closeModal('modal_confirm')">
            <v-icon>mdi-close</v-icon>
          </div>
          <v-row>
            <v-col cols="12">
              <div class="text-center">
                <v-form @submit.prevent="tryConfirmBooking()" class="bb-gray pb-5" ref="form_confirm" v-model="valid_form_confirm">
                  <p class="pa-0 ma-0 text-help">Confermando la prenotazione, <br/>
                    si attesta che l'utente si è recato al centro sportivo effettuando il pagamento.
                  </p>
                  <v-btn color="success" class="ma-2 white--text text-center" type="submit">
                    <v-icon left dark>mdi-account-check-outline</v-icon>
                    CONFERMA PRENOTAZIONE
                  </v-btn>
                </v-form>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import _ from "lodash";
import QrcodeVue from 'qrcode.vue'

export default {
  name: "EditBooking",
  components: {TitlePage,QrcodeVue},
  data() {
    return {
      modal_cancel: false,
      modal_confirm: false,
      qr_url_prefix: '/#/bookings/complete?code=',
      item: {
      },
      transactions: [],
      cancellation: [],
      rules: {
        required: value => !!value || 'Campo richiesto',
        length: v => !v || v.length >= 15 || 'Inserire una motivazione di almeno 15 Caratteri',
      },
      hours_difference: 0,
      booking_cancel:{},
      booking_confirm:{},
      valid_form_cancel: true,
      valid_form_confirm: true,
      loading: false,
      cancellationReason: [],
      reason_choice: ''
    };
  },
  async created(){
    this.setLoading(true);
    let fetchItem = await this.editItem(this.$route.params)
    this.item = Object.assign({},fetchItem.booking)
    this.transactions = Object.assign({},fetchItem.transactions)
    this.cancellation = Object.assign({},fetchItem.cancellations)
    this.getHoursDifference(this.item.date)
    this.cancellationReason = await this.getCancellationReason()
    this.setLoading(false);
  },
  computed: {
    ...mapGetters({
      'getUser':'user/getUser'
    }),
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'editItem':'bookings/edit',
      'cancelBooking':'bookings/cancel',
      'complete': 'bookings/complete',
      'getCancellationReason': 'cancellationReason/index',
    }),

    async tryCancelBooking(){

      this.$refs.form_cancel.validate()
      if(!this.valid_form_cancel){
        return
      }

      await this.setLoading(true);

      try {

        if (this.reason_choice !== 'Altro') {
          this.booking_cancel.reason = this.reason_choice;
        }

        let request = {
          _id: this.booking_cancel._id,
          reason: this.booking_cancel.reason
        }

        let result = await this.cancelBooking(request)

        if(result.success){

          await this.setLoading(false);
          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: 'Prenotazione annullata correttamente'
          })

          let fetchItem = await this.editItem(this.$route.params)
          this.item = Object.assign({},fetchItem.booking)
          this.transactions = Object.assign({},fetchItem.transactions)
          this.cancellation = Object.assign({},fetchItem.cancellations)

          this.modal_cancel = false
          this.booking_cancel = {}

        }else {

          await this.setLoading(false);
          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

        }

      }catch (e) {

        await this.setLoading(false);
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: e.message
        })

      }
    },
    async tryConfirmBooking(){

      this.$refs.form_confirm.validate()
      if(!this.valid_form_confirm){
        return
      }

      await this.setLoading(true);

      try {

        var request = {
          code: this.booking_confirm.code
        }

        var result = await this.complete(request)

        if(result.success){

          await this.setLoading(false);
          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: 'Richiesta di conferma Prenotazione avvenuta correttamente.A breve risulterà confermata sul sistema.'
          })

          var fetchItem = await this.editItem(this.$route.params)
          this.item = Object.assign({},fetchItem.booking)
          this.transactions = Object.assign({},fetchItem.transactions)
          this.cancellation = Object.assign({},fetchItem.cancellations)

          this.modal_confirm = false
          this.booking_confirm = {}

        }else {

          await this.setLoading(false);
          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: 'Riprova più tardi, non è possibile confermare il tuo match'
          })

        }

      }catch (e) {

        await this.setLoading(false);
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }
    },
    cancel(){
      this.modal_cancel = true
      this.booking_cancel = Object.assign({},this.item)
      this.getHoursDifference(this.booking_cancel.date)
      this.booking_cancel.reason = ''
    },
    confirm(){
      this.modal_confirm = true
      this.booking_confirm = Object.assign({},this.item)
    },
    closeModal(type){
      if(type == 'modal_cancel'){
        this.modal_cancel = false
        this.booking_cancel = {}
      }else if(type == 'modal_confirm'){
        this.modal_confirm = false
        this.booking_confirm = {}
      }

    },
    formatDate(slot_id){
      if(!slot_id) return ''
      var split = slot_id.split(';')
      return split[0]+' / '+split[1]+' / '+split[2]+' dalle ore '+split[3]+' alle ore '+split[4]
    },
    getHoursDifference(date){
      var now = new Date()
      var scheduled = new Date(date)
      var diff = (scheduled.getTime() - now.getTime()) / 1000;
      diff /= (60 * 60);
      this.hours_difference = +diff.toFixed(2);
    },
    getPrice(slot, type = 'online') {

      var unit = _.round(+slot.price / 100, 3);
      var online = _.round(+unit * (+slot.split_payment.online_percentage), 2);
      var center = _.round(+unit * (+slot.split_payment.center_percentage), 2);

      if (type == 'online') {
        return online
      } else if (type == 'center') {
        return center
      } else if (type == 'total') {
        return slot.price
      }
    },

    getActor(actor){
      switch (actor) {
        case 'platform':
          return 'Piattaforma'
        case 'customer':
          return 'Utente'
        case 'center':
          return 'Centro Sportivo'
        default:
          return ''

      }
    },
    getStatus(status, type) {
      switch (status) {
        case "completed":
          return (type == 'name') ? 'Completata' : 'success'
        case "booked":
          return (type == 'name') ? 'Prenotato' : 'primary'
        case "to_be_payed":
          return (type == 'name') ? 'Da Pagare' : 'info'
        case "canceled":
          return (type == 'name') ? 'Annullata' : 'error'
        case "refunded":
          return (type == 'name') ? 'Rimborsata' : 'error'
        case "interrupted":
          return (type == 'name') ? 'Interrotta' : 'warning'
        case "pending":
          return (type == 'name') ? 'In attesa' : 'info'
        case "to_be_confirmed":
          return (type == 'name') ? 'Da confermare' : 'warning'
        default:
          return (type == 'name') ? status : 'info'
      }
    },

    getType(type){
      if(type == 'refund-promocode'){
        return 'Rimborso PromoCode'
      }else if( type == 'payment'){
        return 'Pagamento'
      }else if( type == 'refund-offline'){
        return 'Rimborso Offline'
      }
    },

    getTypeCancellation(type){
      if(type == 'nothing'){
        return 'Nessuno'
      }else if( type == 'fixed'){
        return 'Importo Fisso'
      }
    }

  },
  mounted() {

  },
}
</script>

<style scoped>
.text-help{
  color: #282b50;
  font-weight: 500;
  font-size: 16px;
  line-height: 2;
}
.close-icon{
  position: absolute;
  right: 10px;
  cursor: pointer;
}

.custom-radio {
  margin: 8px;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>